import * as React from 'react';
import { TransProps, useTranslation } from 'react-i18next';

import { Color, IconName } from '../../enums';
import { MenuPositionData } from '../../interfaces';
import { Icon } from '../icon/icon.component';

import { Container, StyledMenuPosition } from './arrowMenu.styled';
import { ArrowMenuProps } from './arrowMenu.types';

export const ArrowMenu: React.FC<ArrowMenuProps> = (props: ArrowMenuProps): JSX.Element => {
  const { positions, className }: ArrowMenuProps = props;
  const { t }: TransProps<never> = useTranslation();

  return (
    <Container className={className}>
      {positions.map((position: MenuPositionData): JSX.Element => (
        <StyledMenuPosition key={position.label} {...position}>
          {t(position.label ?? '')}
          <Icon name={IconName.ArrowRight25} size={15} color={Color.Gray500} />
        </StyledMenuPosition>
      ))}
    </Container>
  );
};
